/* eslint-disable react/style-prop-object */
import React from "react";
import Button from "../../../../../../Helpers/Button/Button";
import trans from "../../../../../../../utils";

const StartEngine = ({ device, setControlsPopup, setIsControlsPopup }) => {
	return (
		<div>
			<p className="text2">
				{trans("Do you want to start the engine for")} “{" "}
				<span className="text1">{device?.name}</span> “ ?
			</p>
			<div className="w-100 flex-row justify-end gap-2 mt-12">
				<Button
					text={trans("Cancel")}
					htmlType="button"
					onClick={() => setControlsPopup("")}
					type={"default"}
				/>
				<Button
					text={trans("Yes")}
					htmlType="button"
					type={"primary"}
					onClick={() => setControlsPopup("")}
				/>
			</div>
		</div>
	);
};

export default StartEngine;
